module.exports = __webpack_public_path__ + "img/asset-51.32da918b.svg";